import { Messages, Contacts, Calendar, SkipioLogo, MegaPhone } from "../Icons";
import { MenuButtonItem, MenuOverlay } from "../Menu";
import { useSkipioApi } from "../../api";
import useWindowSize from "../../hooks/use-screen-size";
import {
  Container,
  ContainerMobile,
  NavbarLink,
  Profile,
  ProfilePicture,
  Logo,
  Links,
} from "./SideNav";

export default function SideNavFallback() {
  const { width } = useWindowSize();
  if (width >= 800) return <NavDesktop />;
  else return <NavMobile />;
}

function NavDesktop() {
  const skipioApi = useSkipioApi();

  const logout = async () => {
    await skipioApi.auth.delete();
    window.location.href = `/`;
  };

  return (
    <Container>
      <div style={{ pointerEvents: "none" }}>
        <NavbarLink to="/app/resource-center" activeClassName="active">
          <Logo>
            <SkipioLogo style={{ color: "#fff" }} />
          </Logo>
        </NavbarLink>
      </div>
      <Links style={{ pointerEvents: "none" }}>
        <NavbarLink to="/app/messages" activeClassName="active">
          <Messages />
        </NavbarLink>

        <NavbarLink to="/app/contacts" activeClassName="active">
          <Contacts />
        </NavbarLink>

        <NavbarLink to="/app/calendar" activeClassName="active">
          <Calendar />
        </NavbarLink>

        <NavbarLink to="/app/campaigns" activeClassName="active">
          <MegaPhone />
        </NavbarLink>
      </Links>

      <Profile>
        <MenuOverlay
          right
          trigger={({ show, ref }) => (
            <ProfilePicture title={""} onClick={show} ref={ref} />
          )}
          content={({ hide }) => (
            <>
              <MenuButtonItem
                onClick={() => {
                  hide();
                  logout();
                }}
              >
                Logout
              </MenuButtonItem>
            </>
          )}
        />
      </Profile>
    </Container>
  );
}

export function NavMobile() {
  return <ContainerMobile />;
}
